import React from "react";

export default function PriceRangeSlider({
  minLimit,
  maxLimit,
  step,
  priceRange,
  onRangeChange,
}) {
  // Defensive check
  if (!Array.isArray(priceRange) || priceRange.length < 2) {
    console.warn("PriceRangeSlider: Invalid priceRange");
    return null;
  }

  const rangeMax = priceRange[1];
  const maxPercent =
    100 - ((rangeMax - minLimit) / (maxLimit - minLimit)) * 100;

  return (
    <div className="relative w-full h-10">
      {" "}
      <div className="absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 bg-gray-200 rounded-full" />
      <div
        className="absolute top-1/2 h-1 -translate-y-1/2 bg-[#FF6216] rounded-full transition-all duration-200"
        style={{
          left: "0%",
          right: `${maxPercent}%`,
        }}
      />
      <input
        type="range"
        min={minLimit}
        max={maxLimit}
        step={step}
        value={rangeMax}
        onChange={onRangeChange}
        className="absolute inset-x-0 top-1/2 -translate-y-1/2 w-full h-8 bg-transparent appearance-none cursor-pointer z-10
                   [&::-webkit-slider-thumb]:appearance-none
                   [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4
                   [&::-webkit-slider-thumb]:rounded-full
                   [&::-webkit-slider-thumb]:bg-[#FF6216]
                   [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white
                   [&::-webkit-slider-thumb]:shadow-md
                   [&::-webkit-slider-thumb]:cursor-pointer
                   [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4
                   [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0"
      />
      {/* Labels - Tight & Compact */}
      <div className="flex justify-between items-center text-xs font-medium">
        <span className="text-gray-500">Min : ₹ {minLimit}</span>
        <span className="text-[#FF6216] font-bold">Max : ₹{rangeMax}</span>
      </div>
    </div>
  );
}
